/**
 * A notice was OPENED (plan.md §37.61, step 61). The API puts `?n=<id>` on
 * the address a push tap or an email button opens (`withOpenId`); once
 * somebody is signed in, this posts `/me/notifications/<id>/opened` once —
 * best-effort, never awaited, never queued (an open that cannot be reported
 * is a figure a little low, not a lost feature) — and takes the parameter off
 * the address, keeping its path, other parameters and hash.
 *
 * Mounted once in the shell (`AppShell`), beside the other boot syncs. It
 * sends nothing about the device (§62: no IP, no user agent — the server
 * records only the time).
 */
import { useEffect } from 'react';
import { api } from '@/lib/api';
import { useAuth } from './AuthProvider';

/** A notification id (cuid): nothing else is sent. */
const NOTICE_ID = /^[a-z0-9]{10,40}$/i;

export function NotificationOpened() {
  const { user } = useAuth();
  const uid = user?.id;
  useEffect(() => {
    if (!uid) return;
    const url = new URL(window.location.href);
    const id = url.searchParams.get('n');
    if (!id || !NOTICE_ID.test(id)) return;
    url.searchParams.delete('n');
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
    void api.post(`/me/notifications/${encodeURIComponent(id)}/opened`).catch(() => undefined);
  }, [uid]);
  return null;
}
